import { api } from '../utils/apiUtils';
import { config } from '../config';

const API_URL = config.API_URI;

const base = (workspaceId) => `${API_URL}/v1/workspaces/${workspaceId}/media`;

export const fetchMediaItems = async (workspaceId, params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.append(k, v);
  });
  const url = `${base(workspaceId)}${qs.toString() ? `?${qs}` : ''}`;
  return api.get(url, { noDedupe: true }, false);
};

export const fetchMediaSummary = async (workspaceId) => {
  return api.get(`${base(workspaceId)}/summary`, { noDedupe: true }, false);
};

export const fetchMediaDuplicates = async (workspaceId, params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.append(k, v);
  });
  const url = `${base(workspaceId)}/duplicates${qs.toString() ? `?${qs}` : ''}`;
  return api.get(url, { noDedupe: true }, false);
};

export const fetchMediaUploaders = async (workspaceId) => {
  return api.get(`${base(workspaceId)}/uploaders`, { noDedupe: true }, false);
};

export const fetchMediaItem = async (workspaceId, itemId) => {
  return api.get(`${base(workspaceId)}/${itemId}`);
};

export const fetchMediaDownloadUrl = async (workspaceId, itemId) => {
  return api.get(`${base(workspaceId)}/${itemId}/download`);
};

export const trashMediaItem = async (workspaceId, itemId, { permanent } = {}) => {
  const url = permanent ? `${base(workspaceId)}/${itemId}?permanent=1` : `${base(workspaceId)}/${itemId}`;
  return api.delete(url);
};

export const restoreMediaItem = async (workspaceId, itemId) => {
  return api.post(`${base(workspaceId)}/${itemId}/restore`, {});
};

export const bulkTrashMedia = async (workspaceId, itemIds) => {
  return api.post(`${base(workspaceId)}/bulk-delete`, { itemIds });
};

export const bulkRestoreMedia = async (workspaceId, itemIds) => {
  return api.post(`${base(workspaceId)}/bulk-restore`, { itemIds });
};

export const bulkPurgeMedia = async (workspaceId, itemIds) => {
  return api.post(`${base(workspaceId)}/bulk-purge`, { itemIds });
};

export const emptyMediaTrash = async (workspaceId) => {
  return api.post(`${base(workspaceId)}/empty-trash`, {});
};

export const recalculateMediaUsage = async (workspaceId) => {
  return api.post(`${base(workspaceId)}/recalculate`, {});
};
